import { render, staticRenderFns } from "./guard_witness_view.vue?vue&type=template&id=0d884d2c&scoped=true"
import script from "./guard_witness_view.vue?vue&type=script&lang=js"
export * from "./guard_witness_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d884d2c",
  null
  
)

export default component.exports